/*
 * @Author: gaofengxiang gaofengxiang@gzsle.com
 * @Date: 2023-09-20 09:36:14
 * @LastEditors: gaofengxiang gaofengxiang@gzsle.com
 * @LastEditTime: 2023-10-08 09:33:36
 * @FilePath: \official-site\src\components\HomeImgList\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';

import image1 from '../../static/homeImgs/1、首页500 无糖茶.jpg';
import image2 from '../../static/homeImgs/2、首页大无糖茶.jpg';
import image3 from '../../static/homeImgs/3、首页多多柠檬茶.jpg';
import image4 from '../../static/homeImgs/4、首页有气草本.jpg';
import image5 from '../../static/homeImgs/5、首页电解质水.jpg';
import image6 from '../../static/homeImgs/6、首页气泡果汁.jpg';
import image7 from '../../static/homeImgs/7、首页果汁茶.jpg';
import image8 from '../../static/homeImgs/8、首页冷链果汁.jpg';
import image9 from '../../static/homeImgs/9、维生素水产品介绍.jpg';
import image10 from '../../static/homeImgs/10、900ml常温果汁.jpg';


import './index.sass';

const list = [image1, image2, image7, image3, image5, image4, image6, image8, image9, image10];

export default function HomeImgList({ ...props }) {
  return (
    <div className='home-img-list-holder'>
      {list.map((url) => (
        <img src={url} key={url} alt='home-img' />
      ))}
    </div>
  );
}
